import React, { useEffect } from 'react';
import "./globals.css";
import Footer from "./components/Footer";
import NavigationBar from "./components/NavigationBar";

const Sponsors = () => {
  useEffect(() => {
    document.title = "IWPFI2026_Sponsors";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-sponsors">
        {/* Header */}
        <section className="sponsors-section">
          <h1 className="sponsors-title">Sponsors</h1>
          <p className="sponsors-intro">
            Thank-you to our Sponsors / Merci à nos partenaires
          </p>
        </section>

        {/* Platinum Sponsors */}
        <section className="sponsors-section">
          <h2 className="sponsors-level-title">Platinum Sponsors</h2>
          {/* <p className="sponsors-coming-soon">Coming soon</p> */}
          <div className="sponsors-grid">
            <div className="sponsor-card">
              <a href="https://www.astrazeneca.ca/en" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/AstraZeneca_Logo.png"
                  alt="AstraZeneca Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://ca.gsk.com/en-ca/home/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                {/* <p className="sponsors-coming-soon">GSK</p> */}
                <img
                  src="./images/GSK_logo.png"
                  alt="GSK Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            {/* <div className="sponsor-card">
              <a href="https://www.sanofi.com/en" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Sanofi_logo.png"
                  alt="Sanofi Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div> */}
          </div>
        </section>

        {/* Gold Sponsors */}
        <section className="sponsors-section">
          <h2 className="sponsors-level-title">Gold Sponsor</h2>
          {/* <p className="sponsors-coming-soon">Coming soon</p> */}
          <div className="sponsors-grid">
            <div className="sponsor-card">
              <a href="https://ca.medical.canon/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Canon_logo.png"
                  alt="Canon Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
          </div>
        </section>

        {/* Silver Sponsors */}
        <section className="sponsors-section">
          <h2 className="sponsors-level-title">Silver Sponsors</h2>
          {/* <p className="sponsors-coming-soon">Coming soon</p> */}
          <div className="sponsors-grid">
            <div className="sponsor-card">
              <a href="https://corelinesoft.com/en/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Coreline_logo.png"
                  alt="Coreline Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://www.cyclomedica.com/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Cyclomedica_logo.png"
                  alt="Cyclomedica Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://www.gehealthcare.com" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/GEHealthcare.png"
                  alt="GE Healthcare Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://www.nvision-quantum.com" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Nvision_logo.png"
                  alt="Nvision Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://roche.com" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Roche_Logo.png"
                  alt="Roche Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://www.siemens-healthineers.com/en-ca" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Siemens_Logo.png"
                  alt="Siemens Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
            <div className="sponsor-card">
              <a href="https://vidalung.ai/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/VIDA_logo.png"
                  alt="VIDA Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
            </div>
          </div>
          
        </section>

        {/* Friends of IWPFI */}
        <section className="sponsors-section">
          <h2 className="sponsors-level-title">Friends of IWPFI</h2>

          <div className="sponsors-grid">
            <div className="sponsor-card">
              <a href="https://www.schulich.uwo.ca/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/SC_logo.png"
                  alt="Schulich Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
              {/* <div className="sponsor-name">Schulich School of Medicine & Dentistry</div> */}
            </div>
            <div className="sponsor-card">
              <a href="https://www.schulich.uwo.ca/medimaging//index.html" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Medical-Imaging.jpg"
                  alt="Medical Imaging Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
              {/* <div className="sponsor-name">Schulich School of Medicine & Dentistry</div> */}
            </div>
            <div className="sponsor-card">
              <a href="https://www.schulich.uwo.ca/respirology//index.html" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/Respirology.png"
                  alt="Respirology Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
              {/* <div className="sponsor-name">Schulich School of Medicine & Dentistry</div> */}
            </div>
            <div className="sponsor-card">
               <a href="https://www.uwo.ca/research/" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/WR_logo.png"
                  alt="Western Research Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
              {/* <div className="sponsor-name">Western Research</div> */}
            </div>
            <div className="sponsor-card">
               <a href="https://www.uwo.ca/index.html" target="_blank" rel="noopener noreferrer">
              <div className="sponsor-logo-wrapper">
                <img
                  src="./images/UWO_logo.png"
                  alt="Western University Logo"
                  className="sponsor-logo"
                />
              </div>
              </a>
              {/* <div className="sponsor-name">Western Research</div> */}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Sponsors;
